import { __awaiter, __extends, __generator, __spreadArray } from "tslib";
import * as React from 'react';
import { AttachmentIcon, Button, Icon, close } from '@wix/answers-ui-libby';
import { FileUploadLimitations, KeyCode } from '@wix/answers-api';
import { AnsViewComp, classNames } from '@wix/answers-lib';
import { namespacedClassnames } from '../../../utils';
export var attachmentsKey = 'attachments';
var maxFileSizeMb = FileUploadLimitations.uploadLimitInBytes / 1000000;
var translationPrefix = "".concat(attachmentsKey);
var Attachments = /** @class */ (function (_super) {
    __extends(Attachments, _super);
    function Attachments() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cancel = false;
        _this.state = {
            error: null,
            progress: null,
            uploadProgress: 0
        };
        _this.tp = function (key, params) {
            return _this.props.t("".concat(translationPrefix, ".").concat(key), params);
        };
        _this.fileInputRef = function (ref) { return _this.inputRef = ref; };
        _this.handleFileInput = function (e) {
            var files = Array.prototype.slice.call(e.target.files, 0);
            files.forEach(_this.maybeUploadFile);
            e.target.value = null;
        };
        _this.maybeUploadFile = function (file) {
            if (!!_this.props.execCaptcha) {
                var uploadCallback = function (captchaToken) { return _this.uploadFile(file, captchaToken); };
                _this.props.execCaptcha(uploadCallback);
            }
            else {
                _this.uploadFile(file);
            }
        };
        _this.uploadFile = function (file, captchaToken) {
            if (captchaToken === void 0) { captchaToken = _this.props.captchaToken; }
            var _a = _this.props, onUpload = _a.onUpload, allowedFileTypes = _a.allowedFileTypes;
            var uploadLimitInBytes = FileUploadLimitations.uploadLimitInBytes, supportedFileTypesForUpload = FileUploadLimitations.supportedFileTypesForUpload;
            var supportedFileTypes = (allowedFileTypes === null || allowedFileTypes === void 0 ? void 0 : allowedFileTypes.map(function (type) { return ".".concat(type); })) || supportedFileTypesForUpload;
            var isSizeOK = file.size < uploadLimitInBytes;
            var isTypeOK = supportedFileTypes.
                indexOf(".".concat((file.name.split('.').pop() || '').toLowerCase())) !== -1;
            if (isSizeOK && isTypeOK) {
                var fileReader_1 = new FileReader();
                _this.setState({ progress: { name: file.name }, error: null });
                fileReader_1.addEventListener('error', function () {
                    var message = _this.tp('read-error');
                    _this.setState({ progress: null, error: { fileName: file.name, message: message }, uploadProgress: 0 });
                    _this.cancel = false;
                });
                fileReader_1.addEventListener('load', function () { return __awaiter(_this, void 0, void 0, function () {
                    var attachment, e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, onUpload(fileReader_1.result, captchaToken, this.onProgress, this.props.useReCaptchaV3)];
                            case 1:
                                attachment = _a.sent();
                                if (this.cancel) {
                                    this.cancel = false;
                                }
                                else {
                                    this.setState({ progress: null, uploadProgress: 0 });
                                    this.props.onChange(__spreadArray(__spreadArray([], this.props.attachments, true), [{ name: file.name, url: attachment.url }], false));
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                e_1 = _a.sent();
                                this.setState({ progress: null, error: { fileName: file.name, message: this.tp('upload-error') } });
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); });
                fileReader_1.readAsDataURL(file);
            }
            else {
                if (isTypeOK) {
                    _this.setState({ error: { fileName: file.name, message: _this.tp('size-error', { maxFileSizeMb: maxFileSizeMb }) } });
                }
                else {
                    _this.setState({
                        error: {
                            fileName: file.name,
                            message: "".concat(_this.tp('type-error'), " ").concat(supportedFileTypes.join(', '))
                        }
                    });
                }
                // setTimeout(() => this.setState({ error: null, uploadProgress: 0 }), 4000);
            }
        };
        _this.closeError = function () {
            _this.setState({ error: null, uploadProgress: 0 });
        };
        _this.onProgress = function (progress) {
            _this.setState({ uploadProgress: progress });
        };
        _this.insertFile = function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (_this.state.progress === null) {
                _this.inputRef.click();
            }
        };
        _this.onCancel = function () {
            _this.cancel = true;
            _this.setState({ progress: null, uploadProgress: 0 });
        };
        _this.removeAttachment = function (fileUrl) {
            var _a = _this.props, attachments = _a.attachments, onChange = _a.onChange;
            onChange(attachments.filter(function (file) { return file.url !== fileUrl; }));
        };
        _this.attachRef = function (elem) {
            if (elem) {
                elem.addEventListener('keyup', function (e) {
                    if (e.keyCode === KeyCode.ENTER || e.keyCode === KeyCode.SPACE) {
                        _this.inputRef.click();
                    }
                });
            }
        };
        _this.removeRef = function (file) { return function (elem) {
            if (elem) {
                elem.addEventListener('keyup', function (e) {
                    if (e.keyCode === KeyCode.ENTER || e.keyCode === KeyCode.SPACE) {
                        _this.removeAttachment(file);
                    }
                });
            }
        }; };
        return _this;
    }
    Attachments.prototype.render = function () {
        var _this = this;
        var _a = this, state = _a.state, tp = _a.tp;
        var attachments = this.props.attachments;
        var attachmentsList = attachments.map(function (file, idx) {
            var removeAttachment = function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this.removeAttachment(file.url);
            };
            return (React.createElement("div", { className: 'attachment', key: idx },
                React.createElement("a", { className: 'attachment-name', href: file.url, target: '_blank' }, file.name),
                React.createElement("span", { ref: _this.removeRef(file.url), tabIndex: 0, className: 'attachment-btn' },
                    React.createElement("button", { tabIndex: -1, onClick: removeAttachment, className: 'remove' }, tp('remove')))));
        });
        var progressComp = state.progress && (React.createElement("div", { key: 'progress', className: 'file-progress' },
            React.createElement("span", { className: 'file-name' }, state.progress.name),
            React.createElement("span", { className: 'attachment-btn' },
                React.createElement("button", { onClick: this.onCancel, className: 'cancel' }, tp('cancel'))),
            React.createElement("div", { className: 'progress-bar' },
                React.createElement("div", { className: 'progress-bar-inner', style: { width: "".concat(state.uploadProgress, "%") } }))));
        var uploadErrorComp = state.error && (React.createElement("div", { key: 'error', className: 'file error' },
            React.createElement(Button, { onClick: this.closeError, type: 'tertiary', className: 'close-error-cta' },
                React.createElement(Icon, { icon: close })),
            React.createElement("div", null, state.error.fileName),
            React.createElement("div", { className: 'error-message' }, state.error.message)));
        return (React.createElement("div", { className: namespacedClassnames('attachments-container') },
            React.createElement("div", { className: 'attachment-list-wrapper' }, attachmentsList),
            progressComp,
            uploadErrorComp,
            React.createElement("div", { tabIndex: 0, ref: this.attachRef, className: classNames('attach-wrapper', { disabled: state.progress !== null }) },
                React.createElement("a", { tabIndex: -1, className: 'attach-button', onClick: this.insertFile },
                    React.createElement(AttachmentIcon, null),
                    React.createElement("span", null, tp('attach'))),
                React.createElement("span", { className: 'max-size' }, tp('max-size', { maxFileSizeMb: maxFileSizeMb }))),
            React.createElement("input", { type: 'file', ref: this.fileInputRef, onChange: this.handleFileInput, style: { display: 'none' } })));
    };
    return Attachments;
}(AnsViewComp));
export { Attachments };
//# sourceMappingURL=index.js.map